module.exports = __webpack_public_path__ + "static/media/Climasense_blanco.c75fb4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/logos/Climasense_blanco.png
// module id = 2797
// module chunks = 3